import { Browser, isNullOrUndefined as isNOU } from '@syncfusion/ej2-base';
import { getScrollableParent } from '@syncfusion/ej2-popups';
import * as events from '../base/constant';
import * as classes from '../base/classes';
import { addClass, removeClass } from '@syncfusion/ej2-base';
/**
 * `FullScreen` module is used to maximize and minimize screen
 */
export class FullScreen {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    /**
     * showFullScreen method
     *
     * @param {MouseEvent} event - specifies the mouse event
     * @returns {void}
     * @hidden
     * @deprecated
     */
    showFullScreen(event) {
        if (this.parent.toolbarSettings.enable === true && this.parent.editorMode !== 'Markdown'
            && !isNOU(this.parent.quickToolbarModule)) {
            this.parent.quickToolbarModule.hideQuickToolbars();
        }
        if (this.parent.showTooltip && !isNOU(document.querySelector('.e-tooltip-wrap'))) {
            this.parent.notify(events.destroyTooltip, { args: event });
        }
        this.scrollableParent = getScrollableParent(this.parent.element);
        if (!this.parent.element.classList.contains(classes.CLS_FULL_SCREEN)) {
            const evenArgs = {
                cancel: false,
                requestType: 'Maximize',
                targetItem: 'Maximize',
                args: event
            };
            this.parent.trigger(events.actionBegin, evenArgs, (beginEventArgs) => {
                if (!beginEventArgs.cancel) {
                    if (this.parent.toolbarSettings.enableFloating &&
                        !this.parent.inlineMode.enable && this.parent.toolbarSettings.enable) {
                        this.parent.getToolbarElement().style.width = '100%';
                        this.parent.getToolbarElement().style.top = '0px';
                    }
                    this.parent.element.classList.add(classes.CLS_FULL_SCREEN);
                    this.toggleParentOverflow(true);
                    if (this.parent.toolbarModule) {
                        if (!this.parent.getBaseToolbarObject().toolbarObj.items[0].properties) {
                            this.parent.getBaseToolbarObject().toolbarObj.removeItems(0);
                        }
                        if (Browser.isDevice) {
                            this.parent.toolbarModule.removeFixedTBarClass();
                        }
                        this.parent.toolbarModule.updateItem({
                            targetItem: 'Maximize',
                            updateItem: 'Minimize',
                            baseToolbar: this.parent.getBaseToolbarObject()
                        });
                    }
                    this.parent.refreshUI();
                    this.parent.trigger(events.actionComplete, { requestType: 'Maximize', targetItem: 'Maximize', args: event });
                }
            });
        }
    }
    /**
     * hideFullScreen method
     *
     * @param {MouseEvent} event - specifies the mouse event
     * @returns {void}
     * @hidden
     * @deprecated
     */
    hideFullScreen(event) {
        if (this.parent.toolbarSettings.enable === true && this.parent.editorMode !== 'Markdown'
            && !isNOU(this.parent.quickToolbarModule)) {
            this.parent.quickToolbarModule.hideQuickToolbars();
        }
        if (this.parent.showTooltip && !isNOU(document.querySelector('.e-tooltip-wrap'))) {
            this.parent.notify(events.destroyTooltip, { args: event });
        }
        if (this.parent.element.classList.contains(classes.CLS_FULL_SCREEN)) {
            const evenArgs = {
                cancel: false,
                requestType: 'Minimize',
                targetItem: 'Minimize',
                args: event
            };
            this.parent.trigger(events.actionBegin, evenArgs, (beginEventArgs) => {
                if (!beginEventArgs.cancel) {
                    this.parent.element.classList.remove(classes.CLS_FULL_SCREEN);
                    const elem = document.querySelectorAll('.e-rte-overflow');
                    for (let i = 0; i < elem.length; i++) {
                        removeClass([elem[i]], ['e-rte-overflow']);
                    }
                    if (this.parent.toolbarModule) {
                        if (!this.parent.getBaseToolbarObject().toolbarObj.items[0].properties) {
                            this.parent.getBaseToolbarObject().toolbarObj.removeItems(0);
                        }
                        this.parent.toolbarModule.updateItem({
                            targetItem: 'Minimize',
                            updateItem: 'Maximize',
                            baseToolbar: this.parent.getBaseToolbarObject()
                        });
                        if (Browser.isDevice && this.parent.inlineMode.enable) {
                            this.parent.toolbarModule.addFixedTBarClass();
                        }
                    }
                    this.parent.refreshUI();
                    this.parent.trigger(events.actionComplete, { requestType: 'Minimize', targetItem: 'Minimize', args: event });
                }
            });
        }
    }
    // eslint-disable-next-line
    toggleParentOverflow(isAdd) {
        if (isNOU(this.scrollableParent)) {
            return;
        }
        for (let i = 0; i < this.scrollableParent.length; i++) {
            if (this.scrollableParent[i].nodeName === '#document') {
                const elem = document.querySelector('body');
                addClass([elem], ['e-rte-overflow']);
            }
            else {
                const elem = this.scrollableParent[i];
                addClass([elem], ['e-rte-overflow']);
            }
        }
    }
    onKeyDown(event) {
        const originalEvent = event.args;
        switch (originalEvent.action) {
            case 'full-screen':
                this.showFullScreen(event.args);
                originalEvent.preventDefault();
                break;
            case 'escape':
                this.hideFullScreen(event.args);
                originalEvent.preventDefault();
                break;
        }
    }
    addEventListener() {
        this.parent.on(events.keyDown, this.onKeyDown, this);
        this.parent.on(events.destroy, this.destroy, this);
    }
    removeEventListener() {
        this.parent.off(events.keyDown, this.onKeyDown);
        this.parent.off(events.destroy, this.destroy);
    }
    /**
     * destroy method
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    destroy() {
        if (isNOU(this.parent)) {
            return;
        }
        if (this.parent.element.classList.contains(classes.CLS_FULL_SCREEN)) {
            this.toggleParentOverflow(false);
        }
        const elem = document.querySelectorAll('.e-rte-overflow');
        for (let i = 0; i < elem.length; i++) {
            removeClass([elem[i]], ['e-rte-overflow']);
        }
        this.removeEventListener();
    }
}
